import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { Button } from "antd";
import styled from "styled-components";

import { fontWeights, sizes } from "../constant/styles";
import ACTIONS from "../store/action";
import { PRIMARY_100, PRIMARY_50, PRIMARY_600, WHITE, GRAY_300, PRIMARY_800 } from "../constant/colors";
import { formPopupsContentKeys } from "../constant/formPopupsContentKeys";

const StyledButton = styled(Button)`
  font-size: ${sizes.medium};
  font-weight: ${fontWeights.semibold};
  background: ${(props) => (props.isOwner ? PRIMARY_50 : PRIMARY_600)};
  color: ${(props) => (props.isOwner ? PRIMARY_600 : WHITE)};
  border: 1px solid ${(props) => (props.isOwner ? PRIMARY_50 : PRIMARY_600)};
  border-radius: 6px;
  height: 31px;
  width: 140px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${(props) => (props.isOwner ? PRIMARY_100 : PRIMARY_800)};
    color: ${(props) => (props.isOwner ? PRIMARY_600 : WHITE)};
    border-color: ${(props) => (props.isOwner ? PRIMARY_100 : PRIMARY_800)};
  }

  &:active {
    background: ${(props) => (props.isOwner ? PRIMARY_100 : PRIMARY_800)};
    color: ${(props) => (props.isOwner ? PRIMARY_600 : WHITE)};
    border-color: ${(props) => (props.isOwner ? PRIMARY_100 : PRIMARY_800)};
  }

  &:focus {
    background: ${(props) => (props.isOwner ? PRIMARY_50 : PRIMARY_600)};
    color: ${(props) => (props.isOwner ? PRIMARY_600 : WHITE)};
    border-color: ${(props) => (props.isOwner ? PRIMARY_50 : PRIMARY_600)};
    box-shadow: 0 0 0 4px rgba(83, 177, 253, 0.3) !important;
  }

  &:disabled {
    background: ${GRAY_300};
    color: ${WHITE};
    border-color: ${GRAY_300};
    &:hover {
      background: ${GRAY_300};
      color: ${WHITE};
      border-color: ${GRAY_300};
    }
  }
`;

const SaveAsNewListComponent = ({ t, id, setFormPopupsAct, disabled, isOwner = false }) => {
  const handleClickButton = (e) => {
    e.stopPropagation();
    e.currentTarget.blur();
    setFormPopupsAct(true, formPopupsContentKeys.ADD_NEW_LIST, true);
  };

  return (
    <StyledButton type="primary" onClick={handleClickButton} disabled={disabled} id={id} isOwner={isOwner}>
      {t("save_as_new_list")}
    </StyledButton>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setFormPopupsAct: (visible, contentKey, isDuplicateMode) =>
    dispatch(ACTIONS.setFormPopups(visible, contentKey, isDuplicateMode))
});

const SaveAsNewList = compose(withTranslation(), connect(null, mapDispatchToProps))(SaveAsNewListComponent);

export default SaveAsNewList;
